import { Card, CardContent, Stack, Typography } from "@mui/material";

const StatCard = ({ icon, label, value, helper, accent }) => (
  <Card sx={{ height: "100%", background: accent || "#fff" }}>
    <CardContent>
      <Stack spacing={1.25}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ color: "text.secondary", fontWeight: 600 }}>{label}</Typography>
          {icon}
        </Stack>
        <Typography variant="h4">{value}</Typography>
        <Typography sx={{ color: "text.secondary" }}>{helper}</Typography>
      </Stack>
    </CardContent>
  </Card>
);

export default StatCard;
